// A bill's identity is its _id, and nothing else. Bill numbers repeat across companies AND
// across financial years (the same company reissues number "254" every year), so any key built
// from the number collapses distinct invoices onto one option — react-select identifies options
// by `value`, so two bills sharing a value means selecting one silently picks the other.
export const billOptionValue = (bill) => {
  if (!bill) return '';
  return String(bill._id || '');
};

// Shared so a bill selected in the form and a bill fetched for the dropdown produce an
// identical option — otherwise the two disagree and react-select can't match the selection.
export const billToOption = (bill) => ({
  value: billOptionValue(bill),
  label: bill.company?.name
    ? `${bill.billNumber} (${bill.company.name})`
    : bill.billNumber,
  data: bill
});
